// extracted by mini-css-extract-plugin
export default {"highlightFont":"index_highlightFont__b9uLi"};